export default __webpack_public_path__ + "static/media/visualising_the_data_1.27edd2d6.png";